import { render, staticRenderFns } from "./Add-Adjustment.vue?vue&type=template&id=482287c0&scoped=true&"
import script from "./Add-Adjustment.vue?vue&type=script&lang=js&"
export * from "./Add-Adjustment.vue?vue&type=script&lang=js&"
import style0 from "./Add-Adjustment.vue?vue&type=style&index=0&id=482287c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482287c0",
  null
  
)

export default component.exports